import DimensionsService from '@/services/codebooks/DimensionsService'

export default {
  namespaced: true,
  state: {
    dimensionsList: []
  },
  getters: {
    dimensionsList: state => state.dimensionsList
  },
  actions: {
    refreshDimensions ({ commit }) {
      return DimensionsService.getAllDimensions()
        .then(list => {
          commit('SET_DIMENSIONS', list)
        })
    }
  },
  mutations: {
    SET_DIMENSIONS (state, list) {
      state.dimensionsList = list
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/codebook/dimensions.js